// removed by extract-text-webpack-plugin
module.exports = {"container":"SearchContainer__container___rDUA_"};